import {FileManager} from 'substance'

class DWFileManager extends FileManager {

    sync() {

        this._cleanUpRejectedProxies()

        return super.sync()
    }

    /**
     * Removes rejected fileproxies which promises
     * have been rejected
     *
     * @private
     */
    _cleanUpRejectedProxies() {
        Object.keys(this.proxies)
            .filter((key) => this.proxies[key].rejected)
            .forEach((rejectedKey) => {
                delete this.proxies[rejectedKey]
            })
    }
}

export {DWFileManager}
